"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRoot = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
exports.GridRoot = styled_components_1.default.div `
  height: 100%;
  border-color: ${({ theme }) => theme.colors.borders.normal};
  border-width: ${components_1.BASE_BORDER_WIDTH};
  border-style: solid;
`;
exports.GridRoot.displayName = 'GridRoot';
//# sourceMappingURL=GridRoot.js.map